import mixpanel from 'mixpanel-browser'

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  debug: false,
  track_pageview: true,
  persistence: 'localStorage',
})

export default {
  install: (app) => {
    app.config.globalProperties.$mixpanel = mixpanel
    app.provide('mixpanel', mixpanel)
  },
}
